import { RouteService } from '@/shared/services';
import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'instruction-step-link',
  templateUrl: './instruction-step-link.component.html',
  styleUrl: './instruction-step-link.component.css',
  standalone: false,
})
export class InstructionStepLinkComponent {
  @Input() text: string = '';
  @Input() appendedText: string = '';
  @Input({ required: true }) link!: string;
  @Input() tooltipMessage: string = '';

  env = environment;
  isHovering = false;

  constructor(private routeService: RouteService) {}

  navigateToGlossaryOfTerms() {
    this.routeService.navigateNewTab('/glossary-of-terms', {
      term_value: this.link,
    });
  }
}
